<template>
  <div class="banner-content max-width">
    <div class="title">{{title}}</div>
    <div class="en-title" v-if="enTitle">{{enTitle}}</div>
    <div class="sub-title" v-html="content"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    enTitle: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.banner-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    max-width: 1366px;
    flex-direction: column;
    text-align: left;
    box-sizing: border-box;
    justify-content: center;
    user-select: none;
    // width: 1366px; // 此处应该与导航栏等宽，但是LOGO有白色区域，导致LOGO不能在视图层与banner文字对齐，所以减去26px(为LOGO白色区域宽度)
    width: 1340px;
    .title {
      font-size: 3.1vw;
      color: #fff;
      margin-bottom: 20px;
      letter-spacing: 15px;
    }
    .en-title{
      font-size: 2vw;
      font-family: Source Han Sans CN;
      margin-bottom: 20px;
      font-weight: 400;
      color: #FFFFFF;
    }
    .sub-title {
      font-size: 15px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      max-width: 494px;
    }
  }
</style>
